(() => {
    'use strict';

    real.events.on('ai:recommend:workspace:users:completed', notification => {
        const widget = $('#widget-' + notification.object.widget.id + '[data-widget-type="people"]:not(.removing)');
        if (widget.length === 0) {
            // Widget cannot be found from display anymore.
            return;
        }
        showRecommendations(widget, notification.object.recommendation.id, notification.object.search_value);
    });

    real.events.on('ai:recommend:workspace:users:failed', notification => {
        const widget = $('#widget-' + notification.object.widget.id + '[data-widget-type="people"]');
        if (widget.length === 0) {
            // Widget cannot be found from display anymore.
            return;
        }
        showRecommendationsFailed(widget, notification.object.message);
    });

    const transition = (
        widget,
        hideElem,
        showElem,
        showReadyFn
    ) => {
        new real.animator()
            .setParentElement(widget)
            .setHideElement(hideElem)
            .setShowElement(showElem)
            .onShowReady(showReadyFn)
            .setAnimDuration(howspace.getAnimationDuration(widget, '--transition-animation-duration'))
            .startAnimation();
    };

    const showRecommendations = (widget, recommendationId, searchValue) => {
        const loadMoreUsersBtn = widget.find('.load-more-users-btn');

        const dataPayload = {
            recommenderlimit: widget.data('show-users-count'),
            recommenderoffset: 0,
            search_value: searchValue,
        };

        const queryParams = $.param(dataPayload);
        const url = howspace.widgets.getUrl(widget) + '/recommendedusers/' + recommendationId + '?' + queryParams;
        real.ajax(url, {
            type : 'GET',
            success : response => {
                const container = widget.find('.people-users');

                if (response.error) {
                    const errorElement = widget.find('.recommendations-error');
                    errorElement.find('.error-message').html(response.error);
                }

                if (response.total_users === 0) {
                    widget.find('.no-recommendations-message').removeClass('d-none');
                    container.html('').addClass('d-none');
                    loadMoreUsersBtn.addClass('d-none');
                } else {
                    widget.find('.no-recommendations-message').addClass('d-none');
                    container.html(response.html).removeClass('d-none');
                    updateLoadMoreButton(loadMoreUsersBtn, response);
                }

                // Transition from loader to users.
                transition(widget, widget.find('.people-loader'), widget.find('.people-users-wrapper'));
                howspace.components.init(container);
            }
        });
    };

    // Load the next page of recommended users and append them to the list. The recommendation
    // already exists, so this hits the recommendedusers endpoint directly (no recalculation).
    const loadMoreRecommendedUsers = (widget, loadMoreUsersBtn) => {
        real.ajax.json(loadMoreUsersBtn.data('next-users-page-href'), {
            type: 'GET',
            success: response => {
                real.button.reset(loadMoreUsersBtn);
                widget.find('.people-users').append(response.html);
                howspace.components.init(widget.find('.people-users'));
                updateLoadMoreButton(loadMoreUsersBtn, response);
            },
            error: () => {
                real.button.reset(loadMoreUsersBtn);
            }
        });
    };

    // Show/hide the "Show more" button based on how many users remain, and keep the
    // remaining-count suffix "(N)" and the next-page href up to date. Shared by the normal
    // list and the recommender list.
    const updateLoadMoreButton = (loadMoreUsersBtn, response) => {
        if (response.users_left === 0) {
            // No more users to show, hide the load more users button.
            loadMoreUsersBtn.addClass('d-none');
            return;
        }

        // More users available, show the load more users button.
        loadMoreUsersBtn.removeClass('d-none');
        loadMoreUsersBtn.data('next-users-page-href', response.next_users_page_href);

        // Replace the users left count in the button text.
        let html = loadMoreUsersBtn.html();
        html = html.replace(/\(\d+\)$/, '') + '(' + response.users_left + ')';
        loadMoreUsersBtn.html(html);
    };

    const showRecommendationsFailed = (widget, errorMessage) => {
        widget.find('.load-more-users-btn').addClass('d-none');

        const errorElement = widget.find('.recommendations-error');
        errorElement.find('.error-message').html(errorMessage);
        errorElement.removeClass('d-none');

        // Transition from loader to users.
        transition(widget, widget.find('.people-loader'), widget.find('.people-users-wrapper'));
    };

    const searchPeople = (widget, loadMore = false) => {
        const loadMoreUsersBtn = widget.find('.load-more-users-btn');

        if (loadMore) {
            real.button.loading(loadMoreUsersBtn);
            requestUsers(widget, loadMore, loadMoreUsersBtn);
            return;
        }

        if (!widget.find('.people-users-wrapper').is(':visible')) {
            requestUsers(widget, loadMore, loadMoreUsersBtn);
            return;
        }

        // Transition from users to loader.
        transition(widget, widget.find('.people-users-wrapper'), widget.find('.people-loader'), () => {
            requestUsers(widget, loadMore, loadMoreUsersBtn);
        });
    };

    const requestUsers = (widget, loadMore, loadMoreUsersBtn) => {
        if (widget.data('use-recommender')) {
            if (loadMore && loadMoreUsersBtn.data('next-users-page-href')) {
                // Recommendation already calculated, fetch the next page and append.
                loadMoreRecommendedUsers(widget, loadMoreUsersBtn);
            } else {
                // Initial load, request (and if needed calculate) the recommendation.
                handleRecommender(widget);
            }
            return;
        }

        let url = real.baseUri + '/widget/people/' + widget.data('widget-id') + '/users';

        if (loadMore && loadMoreUsersBtn.data('next-users-page-href')) {
            url = loadMoreUsersBtn.data('next-users-page-href');
        } else {
            const dataPayload = {
                limit: widget.data('show-users-count'),
                sort_order: widget.data('sort-order') || 'asc',
                search_value: widget.find('.people-search-input').val() || ''
            };

            dataPayload.sort_by = 'first_name,last_name,email';
            if (widget.data('sort-by') && widget.data('sort-by') !== 'name') {
                dataPayload.sort_by = widget.data('sort-by');
            }

            url += '?' + $.param(dataPayload);
        }

        real.ajax.json(url, {
            type: 'GET',
            success: response =>  {
                renderUsers(widget, loadMore, loadMoreUsersBtn, response);
            },
            error: () =>  {
                real.button.reset(loadMoreUsersBtn);
            }
        });
    };

    const renderUsers = (widget, loadMore, loadMoreUsersBtn, response) => {
        real.button.reset(loadMoreUsersBtn);
        widget.find('.people-no-users-msg').addClass('d-none');

        if (response.total_users === 0) {
            widget.find('.people-users').html('');
            widget.find('.people-no-users-msg').removeClass('d-none');
        }

        updateLoadMoreButton(loadMoreUsersBtn, response);

        if (loadMore) {
            // Append new users to the UI.
            widget.find('.people-users').append(response.html);
            howspace.components.init(widget.find('.people-users'));
            return;
        }

        // Replace the users in the UI.
        widget.find('.people-users').html(response.html);
        howspace.components.init(widget.find('.people-users'));

        // Transition from loader to users.
        transition(widget, widget.find('.people-loader'), widget.find('.people-users-wrapper'));
    };

    const handleRecommender = widget => {
        if (widget.data('recommender-halt-request')) {
            transition(widget, widget.find('.people-loader'), widget.find('.people-users-wrapper'));
            return;
        }

        widget.find('.howspace-loader').removeClass('d-none');

        const dataPayload = {
            widget_type: 'people',
            widget_id: widget.data('widget-id'),
            user_profile_field_ids: widget.data('recommender-user-profile-field-ids').split(','),
        };

        real.ajax.json(real.baseUri + '/api/ai/recommendation/recommend-users', {
            type: 'POST',
            data: JSON.stringify(dataPayload),
            logError: false,
            showErrorNotification: false,
            success: response => {
                // If the recommendation is available, the response contains its id.
                // Otherwise, it will be generated and once ready a UI notification will be sent.
                if (response?.recommendation?.id) {
                    const searchValue = (widget.find('.people-search-input').val() || '').trim();
                    showRecommendations(widget, response.recommendation.id, searchValue);
                }
            },
            error: response => {
                let errorMessage = 'unknown error.';
                real.ajax.loopErrors(response, error => {
                    errorMessage = error.message;
                });
                showRecommendationsFailed(widget, errorMessage);
            }
        });
    };

    howspace.widgets.people = {
        initView: widget => {
            widget.find('.load-more-users-btn').on('click', () => {
                searchPeople(widget, true);
            });

            widget.find('.people-search-input').on(howspace.components.searchInput.SEARCH, () => {
                searchPeople(widget);
            });

            // Init view mode
            searchPeople(widget);
        },
        destroyView: widget => {
            // Empty for now.
        },
        initEdit: widget => {
            const checkAndDisableSaveButton = () => {
                const checkboxesContainer = widget.find('.people-recommender-field-checkboxes');
                const saveButton = widget.find('.save-widget-btn');

                // If the recommender is not used, the save button should be enabled.
                if (widget.find('.use-recommender-checkbox').prop('checked') === false) {
                    saveButton.prop('disabled', false);
                    return;
                }

                // If the recommender is used, the save button should be disabled if no checkboxes are selected.
                if (checkboxesContainer.hasClass('has-error')) {
                    saveButton.prop('disabled', true);
                } else {
                    saveButton.prop('disabled', false);
                }
            };

            widget.find('input[min]').on('blur input change', real.input.validateMin);
            widget.find('input[max]').on('blur input change', real.input.validateMax);

            widget.find('.filter-by-last-seen-type-radio').on('change', e => {
                const collapse = $('#' + $(e.target).attr('aria-controls'));

                if (collapse.length > 0 && collapse.find('input[type="radio"]:checked').length === 0) {
                    collapse.find('input[type="radio"]').first().prop('checked', true);
                }
            });

            widget.find('.people-recommender-field-checkboxes input[type="checkbox"]').on('change', e => {
                howspace.form.validateCheckboxSelection(widget.find('.people-recommender-field-checkboxes input[type="checkbox"]'));
                checkAndDisableSaveButton();
            });

            widget.find('.use-recommender-checkbox').on('change', () => {
                howspace.form.validateCheckboxSelection(widget.find('.people-recommender-field-checkboxes input[type="checkbox"]'));
                checkAndDisableSaveButton();
            });
        },
        destroyEdit: widget => {
            // Empty for now.
        },
        save: (widget, dataPayload) => {
            if (dataPayload.filter_by_last_seen_type === 'none') {
                dataPayload.filter_by_last_seen = 0;
            }
            dataPayload.show_full_name = dataPayload.show_full_name === 'on';
            dataPayload.show_first_name = dataPayload.show_first_name === 'on';
            dataPayload.recommender_user_profile_fields = dataPayload.recommender_user_profile_fields || null;
            dataPayload.show_selected_users = dataPayload.show_selected_users || [];
            dataPayload.show_selected_userlists = dataPayload.show_selected_userlists || [];
            dataPayload.filter_by_custom_profile_fields = {};

            widget.find('.filter-by-profile-fields .profile-field').each(function () {
                const profileField = $(this);
                const type = profileField.data('profile-field-type');

                if (type === 'organization') {
                    const value = profileField.find('select').val();
                    if (value && value.trim() !== '') {
                        dataPayload.filter_by_custom_profile_fields[profileField.data('profile-field-id')] = value;
                    }
                } else if (type === 'multiple_choice') {
                    const value = [];
                    profileField.find('input[type="checkbox"]:checked').each(function () {
                        value.push(this.value);
                    });
                    if (value.length > 0) {
                        dataPayload.filter_by_custom_profile_fields[profileField.data('profile-field-id')] = value;
                    }
                } else {
                    throw new Error('No handler for profile field type "' + type + '" yet.');
                }
            });

            switch (widget.find('.people-show-roles-radio:checked').val()) {
                case 'admins_and_participants':
                    dataPayload.show_admins = true;
                    dataPayload.show_participants = true;
                    break;

                case 'admins':
                    dataPayload.show_admins = true;
                    dataPayload.show_participants = false;
                    break;

                case 'participants':
                    dataPayload.show_admins = false;
                    dataPayload.show_participants = true;
                    break;

                case 'selected_entities':
                    dataPayload.show_admins = false;
                    dataPayload.show_participants = false;

                    if (dataPayload.show_selected_users.length === 0 && dataPayload.show_selected_userlists.length === 0) {
                        dataPayload.show_admins = true;
                        dataPayload.show_participants = true;
                    }
            }

            dataPayload.show_only_content_custom_profile_fields = [];
            widget.find('.show-only-content-radio:checked').each(function () {
                const radio = $(this);
                if (widget.find('.show-custom-profile-field-checkbox[value="' + radio.val() + '"]:checked').length > 0) {
                    dataPayload.show_only_content_custom_profile_fields.push(radio.val());
                }
            });

            real.ajax.json(howspace.widgets.getApiUrl(widget), {
                type: 'POST',
                data: JSON.stringify(dataPayload),
            });
        },
    };
})();
